import React from "react";
import { Button as AntButton, ButtonProps as AntButtonProps } from "antd";
import styled from "styled-components";

export interface ButtonProps extends AntButtonProps {}

const Button: React.FC<ButtonProps> = (props: ButtonProps) => {
  const { children, ...rest } = props;

  return <StyledButton {...rest}>{children}</StyledButton>;
};

Button.defaultProps = {
  type: "primary",
  htmlType: "button",
};
const StyledButton = styled(AntButton)`
  &&::after {
    display: none;
  }
`;
export default Button;
